import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from '@phosphor-icons/react';

export default function PrivacyPolicy() {
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-4 sm:px-6 py-10" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors mb-8 text-sm" data-testid="privacy-back-link">
          <ArrowLeft weight="bold" className="w-4 h-4" /> Back to GRIT.FIT
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <Shield weight="fill" className="w-10 h-10 text-[#FF3B30]" />
          <div>
            <div className="label-tactical text-[#FF3B30]">Legal</div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter">PRIVACY POLICY</h1>
          </div>
        </div>
        <p className="text-[#71717A] text-sm mb-10">Last updated: {today}</p>

        <div className="space-y-8 text-[#D4D4D8] text-sm sm:text-base leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. What We Collect</h2>
            <p>We collect only what's needed to deliver the service:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1 text-[#A1A1AA]">
              <li><span className="text-white font-bold">Account data:</span> email, name, hashed password, fitness level, goals</li>
              <li><span className="text-white font-bold">Workout data:</span> sessions completed, duration, streak, mood logs (optional)</li>
              <li><span className="text-white font-bold">Push subscription data:</span> endpoint URL, encryption keys, reminder time, timezone (if you enable notifications)</li>
              <li><span className="text-white font-bold">Payment data:</span> handled entirely by Stripe. We never see or store your full card number.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. How We Use It</h2>
            <p>To provide, personalize, and improve the service — generate AI plans, track your streak, send reminders you've opted into, and show leaderboards (only if you opt in via the public_profile toggle).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. What We Never Do</h2>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA]">
              <li>Sell your data to advertisers or data brokers</li>
              <li>Track you across the web with ad trackers</li>
              <li>Share workout or mood data with other users unless you explicitly opt into public leaderboards</li>
              <li>Read your emails or contacts</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Third Parties</h2>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA]">
              <li><span className="text-white font-bold">Stripe</span> — payment processing (their <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#FF3B30] underline">privacy policy</a>)</li>
              <li><span className="text-white font-bold">OpenAI / Anthropic / Google</span> — AI workout plan generation. We send your fitness goals and level. We do NOT send your name, email, or medical data.</li>
              <li><span className="text-white font-bold">Web Push providers</span> — Google FCM, Mozilla autopush, Apple APNs — for push notification delivery only.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Your Rights</h2>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA]">
              <li><span className="text-white font-bold">Export:</span> Download all your workout data as CSV or JSON from Profile</li>
              <li><span className="text-white font-bold">Delete:</span> Contact us to delete your account and all associated data</li>
              <li><span className="text-white font-bold">Opt out:</span> Disable push notifications and public leaderboards anytime in Profile</li>
              <li><span className="text-white font-bold">GDPR / CCPA:</span> If you're in the EU, UK, or California, you have the right to access, rectify, and erase your data. Contact us.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Data Retention</h2>
            <p>Workout data is retained for the life of your account. If you delete your account, all personal data is permanently erased within 30 days, except where required for legal/tax purposes (e.g., Stripe transaction records).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Children</h2>
            <p>GRIT.FIT is not intended for users under 13 (16 in the EU). We do not knowingly collect data from children.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Changes</h2>
            <p>If we materially change this policy, we'll notify active users by in-app banner or email. The date at the top always reflects the current version.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. Contact</h2>
            <p>Questions? Email us — contact info listed in your account billing portal or on our landing page.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-sm">
          <Link to="/terms" className="text-[#A1A1AA] hover:text-white transition-colors" data-testid="privacy-to-terms">→ Terms of Service</Link>
          <Link to="/" className="text-[#A1A1AA] hover:text-white transition-colors">← Back to GRIT.FIT</Link>
        </div>
      </div>
    </div>
  );
}
